// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-825e685c] .el-drawer__body {\n  overflow: auto;\n}\n.container p[data-v-825e685c] {\n  color: rgba(0, 0, 0, 0.647059);\n  margin-bottom: 15px;\n}\n.container h4[data-v-825e685c] {\n  margin-bottom: 10px;\n}\n.feedback_container[data-v-825e685c] {\n  color: rgba(0, 0, 0, 0.647059);\n  font-size: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
